import { CharacterStory } from "../../../domain/models/CharacterStory";

export class CharacterStoryConverter {
  /**
   * Converts Firebase Realtime Database snapshot data to CharacterStory.
   *
   * @param data The Firebase snapshot data from characterStories/EN/<cid>/<cardId>
   * @param characterId The character identifier (char_…)
   * @param cardId The card identifier
   * @returns CharacterStory object or null if data is invalid
   */
  static fromFirebase(
    data: Record<string, unknown> | null | undefined,
    characterId: string,
    cardId: string,
  ): CharacterStory | null {
    if (!data || typeof data !== "object") {
      return null;
    }

    if (typeof data.story !== "string" || data.story.length === 0) {
      return null;
    }

    return {
      characterId,
      cardId,
      story: data.story,
      tone: Array.isArray(data.tone)
        ? data.tone.filter((entry: unknown) => typeof entry === "string")
        : [],
    };
  }
}
